export default __webpack_public_path__ + "static/media/authentication-bg.6730ae01.svg";